((window) => {
  window.media = {
    mobile: window.matchMedia('(max-width: 599px)'),
    tablet: window.matchMedia('(min-width: 600px) and (max-width: 1023px)'),
    desktop: window.matchMedia('(min-width: 1024px) and (max-width: 1919px)'),
    'desktop-min': window.matchMedia('(min-width: 1024px)'),
    ultrawide: window.matchMedia('(min-width: 1920px)')
  };

  const responsiveHandler = (handler) => (e) => e.matches && handler();
  const responsive = (display, handler, init = true) =>
    (init && window.media[display].matches ? handler() || true : true) &&
    window.media[display] &&
    window.media[display].addListener(responsiveHandler(handler));

  window.responsive = responsive;
  return window;
})(window);
